import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";

const statusConfig = {
  Open: {
    label: "Açık",
    className: "text-danger",
  },
  AgencyReplied: {
    label: "Acente Yanıtladı",
    className: "text-warning",
  },
  SuperAdminReplied: {
    label: "Yetkili Yanıtladı",
    className: "text-success",
  },
  Closed: {
    label: "Kapalı",
    className: "text-primary",
  },
};

const TicketDetails = ({ ticket, formatDate, getStatusBadgeColor }) => {
  const InfoItem = ({
    icon,
    label,
    value,
    isBadge = false,
    badgeColor = "",
  }) => (
    <div className="d-flex align-items-center py-3 border-bottom border-light last-border-none">
      <div className="avatar-xs flex-shrink-0 me-3">
        <div className="avatar-title bg-light text-secondary rounded-circle fs-16">
          <i className={icon}></i>
        </div>
      </div>
      <div className="flex-grow-1">
        <h6 className="mb-1 fs-13 text-dark fw-semibold">
          {isBadge ? (
            <span
              className={`badge bg-${badgeColor}-subtle text-${badgeColor} border border-${badgeColor}-subtle`}
            >
              {value}
            </span>
          ) : (
            value
          )}
        </h6>
        <p className="text-muted mb-0 fs-12">{label}</p>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Col xxl={3}>
        <Card className="border-none shadow">
          <CardHeader
            className="bg-transparent border-bottom border-light"
            style={{ padding: "0.846rem 1rem" }}
          >
            <h5 className="card-title mb-0 text-dark">Talep Bilgileri</h5>
          </CardHeader>
          <CardBody className="pt-2">
            <div className="vstack">
              <InfoItem
                icon="ri-hashtag"
                label="Talep Numarası"
                value={`#${ticket.Id}`}
              />

              <InfoItem
                icon="ri-user-line"
                label="Talep Sahibi"
                value={ticket.UserName || "Bilinmiyor"}
              />

              <InfoItem
                icon="ri-folder-3-line"
                label="Kategori"
                value={ticket.Category || "Genel"}
              />

              <InfoItem
                icon="ri-pulse-line"
                label="Mevcut Durum"
                value={
                  statusConfig[ticket.StatusText]?.label || ticket.StatusText
                }
              />

              <InfoItem
                icon="ri-calendar-event-line"
                label="Oluşturulma Tarihi"
                value={formatDate(ticket.CreatedAt)}
              />

              {ticket.ClosedAt && (
                <InfoItem
                  icon="ri-checkbox-circle-line"
                  label="Kapanma Tarihi"
                  value={formatDate(ticket.ClosedAt)}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TicketDetails;
